import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild, Directive, ChangeDetectionStrategy } from "@angular/core";
import { PaneService } from "../../pane.service";

@Component({
    selector: "app-pane",
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: "./pane.component.html",
    styleUrls: ["./pane.component.css"],
    standalone: false
})
export class PaneComponent {
    @Input() public title!: string;

    @Output() public visibleChange = new EventEmitter<boolean>();

    private _paneService: PaneService;

    private _visible!: boolean;
    public get visible() { return this._visible; }
    public set visible(value: boolean) {
        this._visible = value;

        if (value) {
            this._paneService.paneOpened(this);
        }

        this.visibleChange.next(value);
    }

    public constructor(paneService: PaneService) {
        this._paneService = paneService;
    }

    public toggleVisibility() {
        this.visible = !this.visible;
    }

    public close() {
        this.visible = false;
    }
}

@Directive()
export class PaneChild implements AfterViewInit {
    @ViewChild(PaneComponent) private _container!: PaneComponent;

    public get container() { return this._container; }

    public ngAfterViewInit() {
        this.container.visibleChange.subscribe((visible: boolean) => this.onVisibleChanged(visible));
    }

    public toggleVisibility() {
        this.container.visible = !this.container.visible;
    }

    public show() {
        this.container.visible = true;
    }

    public close() {
        this.container.visible = false;
    }

    protected onVisibleChanged(visible: boolean) { }
}
